/**
 * 04 由 02／05／06 產生：每台 INV 一列，串數、MPPT 數、實際串接容量從其他主檔彙總（ADR-0015）。
 *
 * - INV 清單：05 出現過的 INV 索引，加上 02 的 INV 節點（05 還沒建的案場也產得出列，只是沒串數）
 * - INV 編號、上游節點：02 同一個 inv_index 的 INV 節點；02 沒有就 `INV-<索引+1>`、上游留空
 * - 串列總數：05 有接的串（串列編號非空），空接不算
 * - MPPT 總數：05 的 MPPT 數，底下全空接的 MPPT 也算 —— 它實體上存在
 * - 實際串接容量：06 各串容量加總。06 沒建就留空，不拿銘牌充數（同儕判定靠這個，充數會分錯群）
 *
 * @param {string} siteCode
 * @param {{node_level: string, node_id: string, parent_node_id: string, inv_index: number}[]} topology 02
 * @param {{inv_index: number, mppt_no: number, string_id: string}[]} map 05
 * @param {{inv_index: number, capacity_kwp: string|number}[]} design 06
 */
const buildInverterRows = (siteCode, topology, map, design) => {
  const invNodes = new Map(
    topology.filter((n) => n.node_level === 'INV' && n.inv_index !== null).map((n) => [n.inv_index, n])
  )
  const indexes = [...new Set([...map.map((r) => r.inv_index), ...invNodes.keys()])].sort((a, b) => a - b)

  return indexes.map((inv) => {
    const slots = map.filter((r) => r.inv_index === inv)
    const strings = design.filter((r) => r.inv_index === inv)
    const kwp = strings.reduce((sum, r) => sum + Number(r.capacity_kwp), 0)
    const node = invNodes.get(inv)
    return {
      site_code: siteCode,
      inv_index: inv,
      inv_id: node ? node.node_id : `INV-${inv + 1}`,
      parent_node_id: node ? node.parent_node_id : null,
      string_count: slots.filter((r) => r.string_id).length || null,
      mppt_count: new Set(slots.map((r) => r.mppt_no)).size || null,
      // 浮點加總 9 × 6.93 會變 62.370000000000005
      actual_kwp: strings.length ? +kwp.toFixed(3) : null
    }
  })
}

export { buildInverterRows }
